import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { triggerTransition } from '@uirouter/redux';
import {hasCoupons} from '../../../selectors/event';
import Translation from '@s/Translation';
import { setCheckoutOverlay } from '@b/checkout/actions/ui';

class CouponEntryButton extends Component {

    handleClick = () => {
        if (this.props.taggableCouponLoading) {
            return true;
        }
        if (typeof this.showDiscountCoupon === 'function') {
            this.showDiscountCoupon();
        }
    }

    render() {
        if (!this.props.hasCoupons) {
            return null;
        }

        return (
            <div className="coupon-entry" style={this.props.taggableCouponLoading ? {opacity: '.5'} : {}}>
                <button
                    className="button--clear coupon-entry__button"
                    onClick={this.handleClick}
                >
                    <i className="icon-tag" aria-hidden="true"></i>
                    <Translation>{'checkout__enter_promo_code'}</Translation>
                </button>
            </div>
        )
    }

    showDiscountCoupon = () => {
        this.props.triggerTransition('coupon');
        this.props.setCheckoutOverlay(true);
    };
}

const mapStateToProps = (state, props) => {
    return {
        hasCoupons: hasCoupons(state),
        taggableCouponLoading: state.couponTag.taggableCouponLoading,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        triggerTransition,
        setCheckoutOverlay,
    },
    dispatch);
}

CouponEntryButton.propTypes = {
    hasCoupons: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(CouponEntryButton)
